import moment from 'moment';
export const getTodayMinutes = (givenDate: Date) => {
	const momentDate = moment(givenDate);
	const startOfDay = momentDate.clone().startOf('day');
	const minutesSinceStartOfDay = momentDate.diff(startOfDay, 'minutes');
	return minutesSinceStartOfDay;
};
